module.exports = __webpack_public_path__ + "img/DUT4100_R.dc2d24eb.png";